// 本地环境配置
module.exports = {
  title: '共创家—商家端管理',
  baseUrl: 'https://applet1.jifenxitong.com/', // 项目地址
  baseApi: '/admin', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  baseApiApplet: '/applet',
  $cdn: ''
};
